import { fetcher } from "./fetcher";

export async function getCsrfToken() {
  const fetched = await fetcher.get('sanctum/csrf-cookie', {
    credentials: 'include',
    mode: 'cors',
    hooks: undefined,
  });
  document.cookie = `XSRF-TOKEN=${fetched.headers.get('XSRF-TOKEN')}`;
}

export function getXsrfToken (): string {
  return decodeURIComponent((
    document.cookie.split('; ').find(cookie => cookie.indexOf('XSRF-TOKEN') > -1) || ''
  )
  .replace(/^XSRF-TOKEN=/, ''));
}